import { useStrategyStore } from '../../../../store/strategy-store/strategy-store';
import { Panel } from '../../../../store/strategy-store/strategy-store.type';
import { SideSectionOtherInitiatives } from './side-section-other-initiatives';
import { SideSectionSelectedInitiative } from './side-section-selected-initiative';
import { SideSectionSelectedEntity } from './side-section-selected-entity';

export const SideSection = () => {
  const activePanel = useStrategyStore((state) => state.activePanel);
  const selectedInitiative = useStrategyStore((state) => state.selectedInitiative);
  const selectedOutcome = useStrategyStore((state) => state.selectedOutcome);
  const selectedGoal = useStrategyStore((state) => state.selectedGoal);

  switch (activePanel) {
    case Panel.Side:
      // Determine which entity is selected and render appropriate component
      if (selectedInitiative) {
        return <SideSectionSelectedEntity entity={selectedInitiative} entityType="initiative" />;
      }
      if (selectedOutcome) {
        return <SideSectionSelectedEntity entity={selectedOutcome} entityType="outcome" />;
      }
      if (selectedGoal) {
        return <SideSectionSelectedEntity entity={selectedGoal} entityType="goal" />;
      }
      // Fallback to old component for backward compatibility
      return <SideSectionSelectedInitiative />;
    case Panel.OtherInitiatives:
      return <SideSectionOtherInitiatives />;
    default:
      return null;
  }
};
